import { useState } from 'react';

export function useToggle(initialValue: any, options: any[]) {
  const [state, setState] = useState(initialValue);
  const handleToggle = () => {
    setState((current: any) => (current === options[0] ? options[1] : options[0]));
  };
  const toggle = () => handleToggle();
  return [state, toggle];
}

export function useBoolToggle(initialValue: boolean) {
  return useToggle(initialValue, [true, false]);
}
